<template lang="pug">
.content.lesson-edit-content
  .row.lesson-edit-body
    .col-md-12.col-md-header
      .header Chỉnh sửa lý thuyết
    .col-md-12(v-if="error")
      .form-group(style="margin: 0;")
        .alert.alert-danger(style="margin: 0;") {{error}}
    .col-md-6.categ-question
      .form-group
        label.control-label Ngày tạo
        input#created_at.form-control(required :value="createdAt" disabled)
    .col-md-6.lv-question
      .form-group
        label.control-label Người tạo
        input#created_by.form-control(required :value="createdBy" disabled)
    .col-md-6.categ-question
      .form-group
        label.control-label Ngày cập nhật
        input#updated_at.form-control(required :value="updatedAt" disabled)
    .col-md-6.lv-question
      .form-group
        label.control-label Người cập nhật
        input#updated_by.form-control(required :value="updatedBy" disabled)
    .clearfix
    .col-md-6.categ-question
      .form-group
        label.control-label Tên lý thuyết *
        input#name.form-control(type='text', placeholder="Tên lý thuyết" required v-model="nameLesson" maxlength=255)
    .col-md-6.lv-question
      .form-group
        label.control-label Danh mục bài học *
        select#category.form-control(@change="onChangeSelect($event, 'category')" required)
          option(v-for='o in categLesson' :value='o.id' :selected="o.id === categoryID") {{o.name}}
    .col-md-6.categ-question
      .form-group
        label.control-label Chọn môn học *
        select#subject-id.form-control(@change="onChangeSelect($event, 'subject')" required)
          option(v-for='o in subjects' :value='o.id' :selected="o.id === subjectID") {{o.name}}
    //- TODO: KHỐI LỚP CHỌN NHIỀU ??
    //- .col-md-6.lv-question.col-grade-id
    //-   .form-group
    //-     label.control-label Chọn khối lớp *
    //-     Select2#grade_id(v-model="gradeID" :options="grades" :settings="settingGrades")
    .col-md-6.lv-question
      .form-group
        label.control-label Chọn khối lớp *
        select#grade.form-control(@change="onChangeSelect($event, 'grade')" required)
          option(v-for='o in grades' :value='o.id' :selected="o.id === gradeID") {{o.name}}
    .clearfix
    .col-md-12.content-large
      .form-group
        label.control-label.text-md-right(for="content") Nội dung lý thuyết
        froala(:tag="'textarea'" :config="config" v-model="content" @input="changeContent($event)")
    .clearfix
    .col-md-12.form-group.box-files
      .box-images
        label.control-label.text-md-right(for="content") 
          strong Ảnh banner : 
            span (Kích thước đề nghị: 680x260 px)
        #list_banner
        .box-item(v-if="o" v-for="(o, index) in lstBanners")
          span.material-icons.remove(@click='deleteBanner(index)') cancel
          img.img-responsive(:src="o.src")
        .box-item.last 
          input(id="banner" name="banner" type="file" accept="image/*" @change="onImageChange")
          span
            i.material-icons.list-action add
            strong Tải ảnh lên
      .clearfix
    .col-md-12.file-attach
      div.attach
        strong File đính kèm
      .box-attach
        .box-selected-file
          input.file(type='file', name='files[]' multiple @change="onFileChange")
          span Chọn file
          label.files Cho phép {{countFiles}} files
        .box-items
          .box-item-attach(v-if="item" v-for="(item, index) in lstFiles")
            label 
              img.fa-paperclip(src='../../assets/images/theory/Mask Group 55.svg')
              span {{item.name}}
              span.material-icons.remove(@click='deleteFile(index)' style='cursor: pointer;') delete
      .clearfix
    .clearfix
    .col-md-12.col-checkbox
      .box-save
        .title.box-item-footer(:style="$isMobile() ? 'top: 0' : ''") LƯU LÝ THUYẾT
        .clearfix(v-if="$isMobile()")
        .box-item-footer
          .item-checkbox
            input(type="checkbox" 
              name="cb_question" 
              id="cb_question"  
              :checked="is_save_edit"
              @click="onCheckSave($event, 3)")
            label(for="cb_question")
            span Lưu lại và chỉnh sửa sau
        .card.card-save
          .card-content.card-content-save
            div(:class="is_save_edit ? 'opacity' : ''")
            .item-checkbox
              input(type="checkbox" name="public_all" id="public_all" disabled :checked="default_public")
              label(for="public_all")
              span Lưu lý thuyết và cho phép học sinh trong toàn hệ thống tìm kiếm được để mua đáp án
            .clearfix
            .item-checkbox
              input(type="checkbox" name="public_pc" id="public_pc" :checked="default_public_pc" @click="onCheckSave($event, 2)")
              label(for="public_pc")
              span Lưu lý thuyết riêng tư (chỉ cho hiển thị trong cộng đồng và lớp học của tôi)
            .box-left(v-if="is_public_pc > 1")
              .row.row-share-class
                .col-md-6
                  .form-group
                    select#class_id.form-control(@change="onChangeSelect($event, 'class')" required)
                      option(value='0' selected disabled) Chọn lớp học bạn muốn chia sẻ trong PC
                      option(v-for='o in classes' :value='o.id') {{o.name}}
              .row.row-class
                .col-md-12
                  .box-item-attach(v-if="item" v-for="(item, index) in lstClassAdded")
                    label
                      img(src="../../assets/images/theory/ic_class.png")
                      span {{item.name}}
                      span.material-icons.remove(@click='deleteClass(index)' style='cursor: pointer;') delete

      .button-handle
        button(class="btn btn-active" @click="validateSave(1)") Cập nhật
        button(type="reset" class="btn btn-rest" @click="validateSave(2)") Huỷ yêu cầu
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import S3FileUpload from '../S3FileUpload/S3FileUpload.js'
import jQuery from 'jquery'
import moment from 'moment'
import MdNotification from '@/core/components/mdNotification'

export default {
  components: {S3FileUpload, jQuery, MdNotification, moment},
  data() {
    return {
      error: null,
      nameLesson: '',
      subjects: [],
      subjectID: 9,
      grades: [],
      gradeID: null,
      lstGrades: [],
      lstGradeIDRemove: [],
      categLesson: [],
      categoryID: null,
      createdAt: null,
      createdBy: null,
      updatedBy: null,
      updatedAt: null,
      limit: 10,
      offset: 0,
      lstBanners: [],
      lstOldBanners: [],
      bannersURL: [],
      lstFiles: [],
      lstOldFiles: [],
      countFiles: 0,
      fileURL: [],
      classes: [],
      lstClassAdded: [],
      oldLstClassAdded: [],
      lstClassIDRemove: [],
      classOriginIDs: [], // ds ID lớp đã thêm default
      is_public: 2, // 1. ko public 2.public
      default_public: true,
      is_public_pc: 1, // 1. ko public 2.public cho PC
      default_public_pc: false,
      is_save_edit: false,
      config: {
        fullPage: true,
        placeholderText: 'Nhập ...',
        charCounterCount: true,
        key: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2==',
        iframe: true,
        immediateVueModelUpdate: true,
        events: {
          'froalaEditor.initialized': function () {
            console.log('initialized')
            // apiKey: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2=='
          },
          'html.get': function (html) {
            // jQuery('#froala_hide').val(this.el.innerHTML)
          }
        }
      },
      settingGrades: {
        multiple: true,
        closeOnSelect: true,
        allowClear: true,
        placeholder: 'Chọn',
        // escapeMarkup: this.buildInpuGrades,
        // templateResult: this.formatFilterGrades,
        containerCssClass: 'custom-container-lsgrades',
        dropdownCssClass: 'custom-dropdown-lsgrades'
      },
      content: '',
      loader: null,
      force: 0,
      // quan li giao an ly thuyet
      lessonPlanningTheoryID: null,
      item: null,
      orderBy: '{id: desc}',
      minContent100: false,
      maxContent65000: false
    }
  },
  methods: {
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    changeContent(content) {
      let keyword = this.$mycontroller.stripHtml(content)
      // console.log('content: ', keyword, keyword.length)
      // if (keyword.length < 100) {
      //   this.minContent100 = false
      //   this.maxContent65000 = false
      // } else if (keyword.length >= 100 && keyword.length <= 65000) {
      //   this.minContent100 = true
      //   this.maxContent65000 = true
      // } else {
      //   this.minContent100 = true
      //   this.maxContent65000 = false
      // }
      if (keyword.length > 65000) {
        this.maxContent65000 = true
      } else {
        this.maxContent65000 = false
      }
    },
    // Xử lý các ô checkbox
    onCheckSave(e, type) {
      if (type === 1) {
        // if (e.target.checked) this.is_public = 2
        // else this.is_public = 1
      } else if (type === 2) {
        if (e.target.checked) {
          this.is_public_pc = 2
          if (this.subjectID !== null && this.subjectID !== '') this.refetchClass()
        } else {
          this.is_public_pc = 1
          for (let i = 0; i < this.lstClassAdded.length; i++) {
            if (this.classOriginIDs.includes(parseInt(this.lstClassAdded[i].id)) && !this.lstClassIDRemove.includes(parseInt(this.lstClassAdded[i].id))) {
              this.lstClassIDRemove.push(parseInt(this.lstClassAdded[i].id))
            }
          }
        }
      } else {
        this.is_save_edit = e.target.checked
      }
    },
    // onChange những selection trong bài tập
    onChangeSelect(e, type) {
      if (type === 'category') {
        this.categoryID = parseInt(e.target.value)
      } else if (type === 'grade') {
        this.gradeID = parseInt(e.target.value)
        this.lstGradeIDRemove = []
        if (!this.lstGrades.includes(parseInt(this.gradeID))) {
          this.lstGradeIDRemove.push(parseInt(this.gradeID))
        }
      } else if (type === 'subject') {
        this.subjectID = parseInt(e.target.value)
        if (this.is_public_pc === 2) this.refetchClass()
      } else if (type === 'class') {
        let obj = {'name': e.target.options[e.target.options.selectedIndex].innerText, 'id': e.target.value}
        this.lstClassAdded.push(obj)
        let indexSlice = this.lstClassIDRemove.findIndex(key => parseInt(key) === parseInt(e.target.value))
        if (indexSlice >= 0) {
          this.lstClassIDRemove.splice(indexSlice, 1)
        }
        this.classes.splice(this.classes.findIndex(({name}) => name === e.target.options[e.target.options.selectedIndex].innerText), 1)
        jQuery('#class_id').val(0)
      }
    },
    // Lấy danh sách lớp khi tick share bài tập vào lớp
    async refetchClass() {
      this.classes = []
      this.lstClassAdded = []
      await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_WITH_SUBJECT),
        fetchPolicy: 'no-cache',
        variables: {
          user_id: this.$store.getters.user,
          subject_id: this.subjectID,
          order_by: {id: 'asc'}
        }
      }).then((res) => {
        this.classes = res.data.classes
        // console.log(res.data.classes)
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
    },
    onImageChange(e) {
      let files = e.target.files || e.dataTransfer.files
      // console.log(files, e)
      if (!files.length) return
      // xu ly banner da co va doi banner moi
      if (this.lstBanners.length > 0) {
        var returnBanner = this.lstBanners.filter(obj => obj.file === '')
        if (returnBanner && returnBanner.length > 0) {
          this.lstOldBanners.push(returnBanner)
        }
      }
      this.lstBanners = []
      for (let i = 0; i < files.length; i++) {
        let obj = {'name': files[i].name, 'file': files[i], 'src': URL.createObjectURL(files[i])}
        this.lstBanners.push(obj)
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.countFiles += files.length
      if (this.countFiles > 10) {
        this.countFiles -= files.length
        this.showNotification('Vui lòng chọn tối đa 10 files đính kèm', 'warning', 'top', 'right', 2000)
        return
      }
      for (let i = 0; i < files.length; i++) {
        let obj = {'name': files[i].name, 'file': files[i], 'src': URL.createObjectURL(files[i])}
        this.lstFiles.push(obj)
      }
    },
    deleteBanner(index) {
      let delFile = this.lstBanners[index]
      this.lstBanners.splice(index, 1)
      if (delFile.file === '') this.lstOldBanners.push(delFile)
      // console.log(this.lstBanners)
    },
    deleteClass(index) {
      this.classes.push(this.lstClassAdded[index])
      if (this.classOriginIDs.includes(parseInt(this.lstClassAdded[index].id)) && !this.lstClassIDRemove.includes(parseInt(this.lstClassAdded[index].id))) {
        this.lstClassIDRemove.push(parseInt(this.lstClassAdded[index].id))
      }
      this.lstClassAdded.splice(index, 1)
    },
    deleteFile(index) {
      let delFile = this.lstFiles[index]
      this.lstFiles.splice(index, 1)
      this.countFiles--
      if (delFile.file === '') this.lstOldFiles.push(delFile)
    },
    checkForm() {
      if (this.nameLesson === null || this.nameLesson === '') {
        this.showNotification('Vui lòng nhập tên lý thuyết', 'warning', 'top', 'right', 2000)
        this.error = 'Vui lòng nhập tên lý thuyết.'
        return false
      } else if (this.categLesson === null || this.categLesson.length === 0) {
        this.showNotification('Vui lòng tạo danh mục bài học', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng tạo Danh mục bài học.'
        return false
      } else if (this.subjects === null || this.subjects.length === 0) {
        this.showNotification('Vui lòng tạo môn học', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng tạo Môn học.'
        return false
      } else if (this.grades === null || this.grades.length === 0) {
        this.showNotification('Vui lòng tạo khối lớp', 'warning', 'top', 'right', 5000)
        this.error = 'Vui lòng tạo Khối lớp.'
        return false
      // } else if (this.gradeID === null || this.gradeID.length === 0) {
      //   this.showNotification('Vui lòng chọn khối lớp', 'warning', 'top', 'right', 5000)
      //   this.error = 'Vui lòng chọn Khối lớp.'
      //   return false
      // } else if (this.categoryID === null) {
      //   this.showNotification('Vui lòng chọn danh mục bài học', 'warning', 'top', 'right', 2000)
      //   this.error = 'Vui lòng chọn danh mục Bài học.'
      //   return false
      } else if (this.$mycontroller.stripHtml(this.content).length === 0) {
        this.showNotification('Vui lòng nhập nội dung lý thuyết', 'warning', 'top', 'right', 2000)
        this.error = 'Vui lòng nhập nội dung thuyết.'
        return false
      } else if (this.maxContent65000) {
        this.showNotification('Vui lòng nhập tối đa 65000 ký tự', 'warning', 'top', 'right', 2000)
        this.error = 'Vui lòng nhập tối đa 65000 ký tự.'
        return false
      // } else if (!this.minContent100 && !this.maxContent65000) {
      //   this.showNotification('Vui lòng nhập tối thiếu 100 ký tự', 'warning', 'top', 'right', 2000)
      //   this.error = 'Vui lòng nhập tối thiếu 100 ký tự'
      //   return false
      // } else if (this.minContent100 && !this.maxContent65000) {
      //   this.showNotification('Vui lòng nhập tối đa 65000 ký tự', 'warning', 'top', 'right', 2000)
      //   this.error = 'Vui lòng nhập tối đa 65000 ký tự'
      //   return false
      } else {
        if (!this.is_save_edit && this.is_public_pc === 2) {
          if (this.lstClassAdded.length === 0) {
            this.showNotification('Vui lòng chọn lớp học muốn chia sẻ', 'warning', 'top', 'right', 5000)
            this.error = 'Vui lòng chọn lớp học muốn chia sẻ.'
            return false
          }
        }
        this.error = ''
        return true
      }
    },
    // Validate lý thuyết
    async validateSave(type) {
      if (type === 1) {
        if (!this.checkForm()) {
          return
        }
        this.show()
        let variables = {
          where: {
            id: {'_eq': this.item.id}
          },
          changes: {
            category_id: parseInt(this.categoryID),
            subject_id: parseInt(this.subjectID),
            grade_id: parseInt(this.gradeID),
            name: this.nameLesson,
            content: this.content,
            content_plain_text: this.$mycontroller.stripHtml(this.content),
            is_public: this.is_public,
            is_public_pc: this.is_public_pc,
            is_complete: !this.is_save_edit,
            updated_by: this.$store.getters.user
          }
        }
        // console.log(variables)
        await this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_LESSON2),
          variables: variables,
          update: async (store, { data: { update_lesson } }) => {
            if (update_lesson.affected_rows) {
              let returning = update_lesson.returning[0]
              // console.log('UPDATE LESSON: ', returning)
              await this.updateBanners(returning.id)
              await this.updateFiles(returning.id)
              await this.createLessonGrade(returning.id)
              await this.createLessonClass(returning.id)
            }
          }
        }).catch((error) => {
          this.loader.hide()
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
          this.showNotification(error, 'warning', 'top', 'right', 2000)
          console.error(error)
        })
      } else {
        if (this.lessonPlanningTheoryID !== null) {
          this.$router.push({name: 'lesson_planning_lesson', query: {id: this.lessonPlanningTheoryID}})
        } else {
          this.$router.push('/lessons')
        }
      }
    },
    async createLessonClass(lessonID) {
      // console.log('create lesson class: ', this.lstClassAdded, this.classOriginIDs)
      if (this.lstClassAdded !== null && this.lstClassAdded.length > 0) {
        let today = new Date()
        let tzDate = today.toISOString()
        for (let c = 0; c < this.lstClassAdded.length; c++) {
          let elClass = this.lstClassAdded[c]
          if (!this.classOriginIDs.includes(parseInt(elClass.id))) {
            await this.$apollo.mutate({
              mutation: gql(graphql.CREATE_LESSON_CLASSES),
              variables: {
                objInput: {
                  lesson_id: lessonID,
                  class_id: parseInt(elClass.id),
                  start_date: tzDate
                }
              }
            }).catch((error) => {
              this.loader.hide()
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
              console.error(error)
            })
          } else {
            await this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_LESSON_CLASSES),
              variables: {
                objInput: {
                  start_date: tzDate
                },
                objWhere: {
                  lesson_id: {'_eq': lessonID},
                  class_id: {'_eq': elClass.id}
                }
              }
            }).catch((error) => {
              this.loader.hide()
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
              console.error(error)
            })
          }
        }
      }
      // console.log('lstClassIDRemove: ', this.lstClassIDRemove)
      if (this.lstClassIDRemove.length > 0) {
        for (let i = 0; i < this.lstClassIDRemove.length; i++) {
          await this.$apollo.mutate({
            mutation: gql(graphql.DELETE_LESSON_CLASS),
            variables: {
              objWhere: {
                lesson_id: {'_eq': lessonID},
                class_id: {'_eq': parseInt(this.lstClassIDRemove[i])}
              }
            }
          }).catch((error) => {
            this.loader.hide()
            this.showNotification(error, 'danger', 'top', 'right', 2000)
            this.error = error.message
            console.error(error)
          })
        }
      }
      this.loader.hide()
      this.showNotification('Cập nhật lý thuyết thành công', 'success', 'top', 'right', 2000)
      // console.log('lessonPlanningTheoryID: ', this.lessonPlanningTheoryID)
      if (this.lessonPlanningTheoryID !== null) {
        this.$router.push({name: 'lesson_planning_lesson', query: {id: this.lessonPlanningTheoryID}})
      } else {
        this.$router.push('/lessons')
      }
    },
    async createLessonGrade(lessonID, isDone = false) {
      if (this.lstGradeIDRemove.length > 0) {
        for (let i = 0; i < this.lstGradeIDRemove.length; i++) {
          await this.$apollo.mutate({
            mutation: gql(graphql.DELETE_EXERCISE_GRADE),
            variables: {
              lesson_id: lessonID,
              grade_id: parseInt(this.lstGradeIDRemove[i])
            }
          }).catch((error) => {
            this.loader.hide()
            this.showNotification(error, 'danger', 'top', 'right', 2000)
            this.error = error.message
            console.error(error)
          })
        }
      }
      if (this.gradeID === null) this.gradeID = parseInt(this.grades[0].id)
      if (this.gradeID !== null) {
        if (!this.lstGrades.includes(parseInt(this.gradeID))) {
          let variables = {
            object: [{
              lesson_id: lessonID,
              grade_id: this.gradeID,
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user
            }]
          }
          await this.$apollo.mutate({
            mutation: gql(graphql.CREATE_LESSON_GRADE),
            variables: variables
          }).catch((error) => {
            this.loader.hide()
            if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
              this.$router.go(0)
            }
            console.error(error)
          })
        }
        if (isDone) {
          this.loader.hide()
          this.showNotification('Cập nhật lý thuyết thành công', 'success', 'top', 'right', 2000)
          if (this.lessonPlanningTheoryID !== null) {
            this.$router.push({name: 'lesson_planning_lesson', query: {id: this.lessonPlanningTheoryID}})
          } else {
            this.$router.push('/lessons')
          }
        }
      }
    },
    async updateFiles(lessonID) {
      // console.log('updateFiles')
      if (this.lstFiles.length > 0) {
        let directory = 'files/lessons'
        let config = S3FileUpload.computed.config(directory)
        let S3Client = new S3FileUpload.computed.S3Client(config)
        for (let index = 0; index < this.lstFiles.length; index++) {
          let attach = this.lstFiles[index]
          let file = attach.file
          let src = attach.src
          if (file !== '') {
            let fileName = attach.name.split('.')[0].replace(/ /g, '')
            let random = Math.random().toString().slice(2)
            let fieldName = `${random}_${fileName}`
            await S3Client.uploadFile(file, fieldName).then((data) => {
              this.fileURL.push(data.location)
            })
          } else {
            this.fileURL.push(src)
          }
        }
      }
      if (this.lstOldFiles.length > 0) {
        let directory = 'files/lessons'
        let config = S3FileUpload.computed.config(directory)
        let S3Client = new S3FileUpload.computed.S3Client(config)
        for (let index = 0; index < this.lstOldFiles.length; index++) {
          let fileName = this.lstOldFiles[index].name
          await S3Client.deleteFile(fileName)
        }
      }
      if (this.fileURL.length > 0) {
        await this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_LESSON2),
          variables: {
            where: {
              id: {'_eq': lessonID}
            },
            changes: {
              files: '{' + this.fileURL.join() + '}'
            }
          }
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
          console.log(error)
        })
      }
    },
    async updateBanners(lessonID) {
      // console.log('updateBanners')
      if (this.lstBanners.length > 0) {
        let directory = 'images/lessons'
        let config = S3FileUpload.computed.config(directory)
        let S3Client = new S3FileUpload.computed.S3Client(config)
        for (let index = 0; index < this.lstBanners.length; index++) {
          let banner = this.lstBanners[index]
          let file = banner.file
          let src = banner.src
          if (file !== '') {
            // let fileName = banner.name.split('.')[0].replace(/ /g, '')
            let arrFileName = banner.name.split('.')
            let tagImage = arrFileName[arrFileName.length - 1]
            let fileName = 'banner.' + tagImage
            let random = Math.random().toString().slice(2)
            let fieldName = `${random}_${fileName}`
            await S3Client.uploadFile(file, fieldName).then((data) => {
              this.bannersURL.push(data.location)
            })
          } else {
            this.bannersURL.push(src)
          }
        }
      }
      if (this.lstOldBanners.length > 0) {
        let directory = 'images/lessons'
        let config = S3FileUpload.computed.config(directory)
        let S3Client = new S3FileUpload.computed.S3Client(config)
        for (let index = 0; index < this.lstOldBanners.length; index++) {
          let fileName = this.lstOldBanners[index].name
          await S3Client.deleteFile(fileName)
        }
      }
      if (this.bannersURL.length > 0) {
        await this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_LESSON2),
          variables: {
            where: {
              id: {'_eq': lessonID}
            },
            changes: {
              banner: '{' + this.bannersURL.join() + '}'
            }
          }
        }).catch((error) => {
          if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
            this.$router.go(0)
          }
          console.log(error)
        })
      }
    },
    // Lấy danh sách lớp khi mở lần đầu tiên
    async getClassDefault() {
      await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_WITH_SUBJECT),
        fetchPolicy: 'no-cache',
        variables: {
          user_id: this.$store.getters.user,
          subject_id: this.subjectID,
          order_by: {id: 'asc'}
        }
      }).then((res) => {
        if (res.data.classes && res.data.classes.length > 0) {
          for (let i = 0; i < res.data.classes.length; i++) {
            if (!this.classOriginIDs.includes(res.data.classes[i].id)) {
              this.classes.push(res.data.classes[i])
            }
          }
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
    }
  },
  watch: {
    '$route' (to, from) {
      // on route change re run: onCreated
      // this.onCreated()
      if (from.params.lesson_id !== to.params.lesson_id) {
        this.$router.go(0)
      }
    }
  },
  mounted() {
    // chỉnh sửa bên Giáo án Lý thuyết
    if (this.$route.params.lesson_planning_pc_id !== undefined) {
      this.lessonPlanningTheoryID = parseInt(this.$route.params.lesson_planning_pc_id)
    }
  },
  async created() {
    await this.$apollo.query({
      query: gql(graphql.GET_FIRST_LESSON2),
      variables: {
        where: {
          id: {_eq: this.$route.params.lesson_id},
          is_delete: {_eq: false}
        }
      },
      fetchPolicy: 'no-cache',
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }).then((result) => {
      // console.log(result.data.lesson)
      if (result && result.data && result.data.lesson.length > 0) {
        let item = result.data.lesson[0]
        this.item = item
        this.createdAt = moment(item.created_at).format('DD/MM/YYYY - HH:mm')
        this.updatedAt = moment(item.updated_at).format('DD/MM/YYYY - HH:mm')
        this.createdBy = item.userCreate.fullname || ''
        this.updatedBy = item.userUpdate.fullname || ''
        this.nameLesson = item.name
        this.categoryID = item.category_id
        this.subjectID = item.subject_id
        this.gradeID = item.grade_id
        this.content = item.content !== null && item.content
        this.is_save_edit = !(item.is_complete)
        this.is_public = item.is_public
        this.is_public_pc = item.is_public_pc
        this.default_public = (item.is_public === 2)
        this.default_public_pc = (item.is_public_pc === 2)
        if (item.banner !== null) {
          // console.log(item.banner)
          for (let i = 0; i < item.banner.length; i++) {
            let url = item.banner[i]
            let split = url.split('/')
            let fileName = split[split.length - 1]
            let obj = {'name': fileName, 'file': '', 'src': url}
            this.lstBanners.push(obj)
          }
          // this.lstBanners = item.banner
        }
        if (item.files !== null) {
          // console.log(item.files)
          for (let i = 0; i < item.files.length; i++) {
            let url = item.files[i]
            let split = url.split('/')
            let fileName = split[split.length - 1]
            let obj = {'name': fileName, 'file': '', 'src': url}
            this.lstFiles.push(obj)
          }
          this.countFiles = item.files.length
        }
        let arrGrades = item.lesson_grades
        if (arrGrades !== null && arrGrades.length > 0) {
          for (let index = 0; index < arrGrades.length; index++) {
            this.lstGrades.push(arrGrades[index].grade.id)
          }
        }
        let arrClasses = item.lesson_classes
        if (arrClasses !== null && arrClasses.length > 0) {
          for (let index = 0; index < arrClasses.length; index++) {
            this.lstClassAdded.push(arrClasses[index].class)
            this.classOriginIDs.push(arrClasses[index].class_id)
          }
        }
        this.getClassDefault()
      } else {
        this.showNotification('Vui lòng xem lại, không có lý thuyết này!!', 'danger', 'top', 'right', 2000)
      }
    })
  },
  apollo: {
    grades: {
      query: gql(graphql.GET_GRADES),
      update: data => {
        for (let i = 0; i < data.grades.length; i++) {
          data.grades[i].text = data.grades[i].name
        }
        return data.grades
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error)
      }
    },
    subjects: {
      query: gql(graphql.GET_SUBJECT_USER),
      variables() {
        let variables = {
          where: {
            is_delete: {'_eq': false},
            user_id: {'_eq': this.$store.getters.user},
            status: {'_eq': 2}
          },
          orderBy: {created_at: 'asc'}
        }
        return variables
      },
      update: data => {
        if (data.subject_user.length > 0) {
          let lstSubjects = []
          for (let i = 0; i < data.subject_user.length; i++) {
            lstSubjects.push(data.subject_user[i].subject)
          }
          return lstSubjects
        }
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      }
    },
    categLesson: {
      query: gql(graphql.GET_CATEGORY),
      fetchPolicy: 'no-cache',
      update: data => {
        for (var i = 0; i < data.category.length; i++) {
          data.category[i].selected = false
        }
        return data.category
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error)
      }
    }
  }
}

</script>

<style lang="scss">
.lesson-edit-content {
  .lesson-edit-body {
    .col-md-header {
      margin-bottom: 10px;
    }
    .header {
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #5F6468;
      display: inline-block;
    }
    .lv-question {
      padding-left: 7.5px;
      .form-group {
        label {color: black; font-weight: bold; font-size: 13px !important;}
        margin-top: 0;
        input, select {background-color: white;}
        input#created_by {background: #EAEAEA 0% 0% no-repeat padding-box;}
        input#updated_by {background: #EAEAEA 0% 0% no-repeat padding-box;}
      }
    }
    .categ-question {
      padding-right: 7.5px;
      .form-group {
        label {color: black; font-weight: bold; font-size: 13px !important;}
        margin-top: 0;
        input, select {background-color: white;}
        input#created_at {background: #EAEAEA 0% 0% no-repeat padding-box;}
        input#updated_at {background: #EAEAEA 0% 0% no-repeat padding-box;}
      }
    }
    .content-large {
      .form-group {
        margin-top:0;
        label {color: black; font-weight: bold; font-size: 13px !important;}
      }
    }
    .box-files {
      margin-top: 10px;
      .box-images{
        margin: 0px 0 5px 0; 
        label.control-label{font-size:13px !important;font-weight: bold; padding-bottom:10px;color:#333;}
        strong span{color:#969FAD !important;font-weight: normal !important; }
        .box-item {
          float:left;width: 122px;height: 122px; margin-right:20px;margin-bottom:10px; position: relative;
          img{max-width: 100%; height: auto;    max-height: 100%;}
          span.remove{position: absolute; right: 5px; top:5px;cursor: pointer; color:#f00;}
        }
        .box-item.last {margin-right: 0 !important; background: #EAEAEA 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029;border: 1px solid #EAEAEA;border-radius: 3px;text-align:center;display:table-cell;vertical-align:middle;line-height:122px; cursor: pointer;}
        .box-item.last span{text-align:center; display: inline-block;vertical-align: middle;line-height: normal; position:relative; top: auto; right: auto;}
        .box-item.last strong{display:block; text-align:center;}
      }
    }
    .file-attach {
      margin-bottom: 10px;
      .attach {margin-top:0px;}
      .box-attach{background: #fff; padding: 20px 10px 16px !important; border-radius: 10px; box-shadow: 0px 1px 3px #00000029;}
      .box-item-attach{border-top: 1px solid #EAEAEA !important; padding: 5px 10px !important; }
      .box-item-attach:first-child{margin-top: 15px !important;}
      .box-item-attach:last-child{border-bottom: 1px solid #EAEAEA !important;}
      .box-item-attach label{width: 100%; display:block; color:#000;}
      .box-item-attach .fa-paperclip{transform: rotate(90deg); }
      .box-item-attach span{padding-left: 10px;}
      .box-item-attach .remove{float:right; display:block; z-index: 100;}
      .box-selected-file {padding: 0 10px; position: relative; width: fit-content;
        input.file {position: absolute; opacity: 0;}
      }
      .box-selected-file span{padding: 5px 15px; background: #FFFFFF 0% 0% no-repeat padding-box;border: 0.5px solid #B4B4B4; border-radius: 3px; cursor: pointer;margin-right: 15px;}
      .box-selected-file label.files{color: #969FAD;}
    }
    .col-checkbox {
      .box-save {
        .box-item-footer {
          display: inline-flex;
          &.title {
            color: #9F6A28;
            text-transform: uppercase;
            font-size: 17px;
            font-weight: bold;
            position: relative;
            top: -5px;
            margin-right: 25px;
          }
        }
        .card-save {
          border-radius: 10px;
          margin-top: 0px;
          margin-bottom: 16px;
          .card-content-save {
            .opacity {
              display: block;
              position: absolute;
              width: 100%;
              height: 100%;
              opacity: 0.5;
              background: white;
              z-index: 1;
              left: 0;
              right: 0;
              top: 0;
            }
            .box-left {padding-left: 30px;}
            .row-amount-honey {
              .form-group {margin-top: 0; margin-bottom: 0;
                .form-control {margin-bottom: 0;}
              }
              label {color: #333333; font-weight: bold;}
            }
            .row-share-class {
              .form-group {margin-top: 0;
                .form-control {margin-bottom: 0;}
              }
            }
            .row-class {
              .box-item-attach{border-top: 1px solid #EAEAEA !important;border-left: 1px solid #EAEAEA !important; border-right: 1px solid #EAEAEA !important;padding: 5px 10px !important; }
              .box-item-attach:last-child{border-bottom: 1px solid #EAEAEA !important;}
              .box-item-attach label{width: 100%; display:block; color:#000;}
              .box-item-attach .fa-paperclip{transform: rotate(90deg); }
              .box-item-attach img{ width: 16px; height: 16px;}
              .box-item-attach span{padding-left: 10px;}
              .box-item-attach .remove{float:right; display:block; z-index: 100; font-size: 20px;}
            }
          }
        }
      }
    }
    .col-checkbox {
      margin-top: 0px;
      .button-handle {
        .btn{text-align: left; font-size: 15px;letter-spacing: 0px;color: #333333; padding: 12px 30px; text-transform: inherit;}
        .btn-active{background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px;border: 0 none;}
        .btn-active:nth-child(2) {margin: 0 20px;}
        .btn-rest{border: 0 none; background: transparent; box-shadow: none;}
        .btn-active:hover,.btn-active:active, .btn-active:focus{background: #FFD311 0% 0% no-repeat padding-box; color:#333;box-shadow: none;}
        .btn-rest:hover, .btn-rest:active, .btn-rest:focus{background: transparent;color: #333;box-shadow: none;}
      }
      .item-checkbox{
        display:inline-flex; 
        justify-content: center;
        align-items: center; 
        padding: 7px 0;
        span {margin-left: 8px; font-size: 15px; color: #343A40;}
        input{display:none;}
        input + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box_outline@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block; background-size: cover; margin: 0;}
        input:checked + label{cursor: pointer;background: url("../../assets/images/faces/ic_check_box@2x.png") no-repeat center center;height: 24px;width: 24px;display:inline-block;background-size: cover;}
      }
    }
  }
}
@media (max-width: 414px) {
  .lesson-edit-content {
    .lesson-edit-body {
      .lv-question {padding-left: 15px;}
      .categ-question {padding-right: 15px;}
      .col-checkbox {
        .card-save {
          .card-content-save {
            .item-checkbox{
              input + label{width: 40px;}
              span {text-align: left;}
            }
          }
        }
        .box-item-footer {
          .item-checkbox{
            span {text-align: left;}
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// edit.vue?1332dbdd